<template>
  <div v-loadmore="loadmore">
    <div class="bg-wrap">
      <img src="@/common/image/wallet-bg.png" alt="">
      <div class="box">
        <div class="text">可提现金额：</div>
        <div class="mid">
          <div class="all"><span>￥</span>{{all.withdrawable_total}}</div>
          <!-- <div class="all-spec">已扣税可提现金额200元，未扣税68元</div> -->
        </div>
        <div class="bottom">
          <div>
            <div class="col-name">待结算</div>
            <div class="col-num"><span>￥</span>{{all.settlement_total}}</div>
          </div>
          <div>
            <div class="col-name">累计收入</div>
            <div class="col-num"><span>￥</span>{{all.cumulative_total}}</div>
          </div>
        </div>
        <div class="btn" @click="toTx">
          <div>提现</div>
        </div>
      </div>
    </div>
    <div class="list">
      <div class="title">收入记录<router-link tag="div" class="spec" to="/personal/wallet/spec">钱包与收入说明</router-link></div>
      <div>
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="left">
            <div class="name">{{item.type_text}}</div>
            <div class="course">{{item.journal_name}}</div>
            <div class="time">{{item.createtime}}</div>
          </div>
          <div class="right">{{item.change_amount}}</div>
        </div>
        <div v-if="list.length === 0" class="no-data">暂无记录</div>
      </div>
    </div>
    <loading v-show="loading"></loading>
  </div>
</template>

<script>
import Loading from 'components/base/loading/loading.vue'
import {getUserWalletNew, getUserWalletInList} from '@/api/user-center.js'
import {RES_OK} from '@/api/config'
export default {
  components: {
    Loading
  },
  data() {
    return {
      page: 1,
      list: [],
      loading: false,
      loaded: false,
      all: {}
    }
  },
  created() {
    getUserWalletNew().then(({data}) => {
      if (data.code === RES_OK && data.data) {
        this.all = data.data
      }
    })
    // 加载第一页
    this.loadmore()
  },
  methods: {
    toTx() {
      this.$router.push({
        path: '/personal/wallet/tx?all=' + this.all.withdrawable_total
      })
    },
    loadmore() {
      const size = 10
      if (this.loading || this.loaded) return
      this.loading = true
      getUserWalletInList(this.page, size).then(({data}) => {
        if (data.code === RES_OK && data.data) {
          this.list.push(...data.data)
          this.loading = false
          this.loaded = data.data.length < size
          this.page++
        }
      })
    }
  }
}
</script>

<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .no-data
    color #666
    text-align center
    font-size size(14)
    margin size(80) 0
  .bg-wrap
    min-height size(300)
    position relative
    margin-bottom size(100)
    img
      display block
      width 100%
    .box
      position absolute
      left 0
      top 0
      right 0
      bottom 0
      color #fff
    .text
      font-size size(32)
      font-weight 800
      padding size(36) size(44) 0
    .mid
      text-align center
      padding-top percentage(64 / 750)
      .all
        font-size size(59)
        font-weight 800
        span
          font-size size(32)
      .all-spec
        color rgba(255, 255, 255, 0.58)
        font-size size(24)
        padding-top percentage(24 / 750)
    .bottom
      display flex
      align-items center
      text-align center
      padding 0 percentage(30 / 750)
      position absolute
      left 0
      width 100%
      bottom size(28)
      >div
        flex 1
        &:first-child
          padding-right percentage(100 / 750)
        &:last-child
          padding-left percentage(100 / 750)
      .col-name
        font-size size(24)
        margin-bottom size(20)
      .col-num
        font-size size(32)
        span
          font-size size(20)
    .btn
      position absolute
      left 50%
      bottom 0
      transform translate(-50%, 50%)
      width percentage(160 / 750)
      height percentage(160 / 425)
      border-radius 50%
      background-image linear-gradient(180deg, #fec915 0%, #fec915 100%)
      box-shadow: 0px 3px 6px 1px #fad2ca
      font-size size(34)
      font-weight 800
      display flex
      align-items center
      text-align center
      &:active
        background-image linear-gradient(180deg, #f2bb00 0%, #f2bb00 100%)
      >div
        flex 1
  .list
    padding 0 size(40)
    .title
      padding 0 size(8)
      font-size size(38)
      color #30302e
      font-weight 800
      position relative
      margin-bottom size(24)
      line-height 1.1
      .spec
        width: auto !important
        color #f5a623
        font-size size(24)
        font-weight 500
        position absolute
        right size(8)
        bottom 0
    .item
      margin-bottom size(18)
      box-shadow: 0px 2px 13px 0px #efefef
      border-radius: 10px
      height size(180)
      display flex
      align-items center
      padding 0 size(26)
      .left
        width 76%
      .right
        width 24%
        text-align right
        font-size size(32)
        color #494949
        font-weight 800
      .name
        font-size size(30)
        color #2c2c2c
        font-weight 800
      .course
        color #686868
        font-size size(28)
        white-space nowrap
        overflow hidden
        text-overflow ellipsis
        margin size(20) 0 size(24)
      .time
        font-size size(28)
        color #686868
</style>


// WEBPACK FOOTER //
// src/components/personal/wallet/wallet.vue